namespace RS.Slots.Paytable.Plugins
{
    /**
     * Hide or show buypass text
     */
    export class BuypassPlugin extends RS.ExternalHelp.VisitorPlugin
    {
        private readonly _showBuypass: boolean;
        private readonly _multipliers: string[];
        private readonly _buypassRTP: string;

        public constructor(page: RS.ExternalHelp.IPage)
        {
            super(page);

            this._showBuypass = RS.URL.getParameterAsBool("buypass", true);
            this._multipliers = RS.URL.getParameter("multipliers", "x0,x0,x0,x0").split("|");
            this._buypassRTP = RS.URL.getParameter("buypassRTP");
        }

        public onElementLoaded(element: HTMLElement)
        {
            const isBuypass = element.id === "buypass";
            const isMultiplier = element.classList.contains("buypass-multiplier");
            const isLegalRTP = element.classList.contains("buypass-rtp");
            if (isBuypass && !this._showBuypass)
            {
                RS.ExternalHelp.hideElement(element);
            }
            if (isMultiplier && this._showBuypass)
            {
                const indexStr = element.getAttribute("data-index");
                if (indexStr)
                {
                    element.innerText = this._multipliers[parseInt(indexStr)];
                }
            }
            if (isLegalRTP && this._showBuypass)
            {
                element.innerText = this._buypassRTP;
            }
        }
    }

    RS.ExternalHelp.pluginRegistry.register(BuypassPlugin);
}